module.exports = "<vue-component id=\"footer\" component=\"Footer\" permanent> </vue-component>\n"